import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Wrench, Cube, Gauge, Handshake, Notepad, NotePencil, MapPin, ArrowSquareUpRight, Sparkle, Envelope, Tag, SquaresFour, Blueprint, Hammer } from '@phosphor-icons/react';
import { ModuleSidebar } from '@/components/enterprise/ModuleSidebar';
import { useAuth, isSimpleMenu } from '@/auth/AuthContext';
import { engApi } from './engApi';

// UX consolidation (2026-06): one sidebar owner (ModuleSidebar). Labels name
// the job, not the technology — 「技術ダイジェスト」not 「AIダイジェスト」.
// 2026-06 シンプルメニュー: 場所・カテゴリ品番は 設定 → マスター に寄せ、
// AIの道具は ナレッジ（管理者のみ）へ移す。OFF なら今までのメニューに戻る。
export default function EngineeringLayout() {
  const [access, setAccess] = useState({ is_member: false, is_admin: false });
  const { user } = useAuth();
  const simple = isSimpleMenu(user);
  useEffect(() => { engApi.access().then(setAccess).catch(() => {}); }, []);

  const admin = access.is_admin;
  const sections = [
    { label: '開発', items: [
      { to: '/engineering', end: true, label: 'ダッシュボード', icon: SquaresFour, testid: 'eng-nav-dashboard' },
      { to: '/engineering/developments', label: '開発案件', icon: Blueprint, testid: 'eng-nav-developments' },
    ] },
    { label: '資産管理', items: [
      { to: '/engineering/assets', label: '技術資産', icon: Cube, testid: 'eng-nav-assets' },
      { to: '/engineering/equipment', label: simple ? '設備' : '設備台帳', icon: Gauge, testid: 'eng-nav-equipment' },
      // 2026-06 · 自社製作（3Dプリント等）の依頼。購入品の発注は 部品受注入力 のまま。
      { to: '/engineering/fabrication', label: '製作依頼', icon: Hammer, testid: 'eng-nav-fabrication' },
      { to: '/engineering/rentals', label: '貸出', icon: Handshake, testid: 'eng-nav-rentals' },
      ...(admin && !simple ? [
        { to: '/engineering/shelves', label: '場所マスタ', icon: MapPin, testid: 'eng-nav-shelves' },
        { to: '/engineering/taxonomy', label: 'カテゴリ・品番', icon: Tag, testid: 'eng-nav-taxonomy' },
      ] : []),
    ] },
    { label: '日報・データ', items: [
      { to: '/engineering/reports', label: '日報', icon: NotePencil, testid: 'eng-nav-reports' },
      { to: '/engineering/forms', label: 'データ収集', icon: Notepad, testid: 'eng-nav-forms' },
    ] },
    ...(simple ? [] : [{ label: 'ダイジェスト・出力', items: [
      { to: '/engineering/ai-digest', label: '技術ダイジェスト', icon: Envelope, testid: 'eng-nav-ai-digest' },
      { to: '/engineering/kb-export', label: 'ナレッジ出力', icon: ArrowSquareUpRight, testid: 'eng-nav-kb-export' },
      ...(admin ? [
        { to: '/engineering/ai-feedback', label: '読み取りフィードバック', icon: Sparkle, testid: 'eng-nav-ai-feedback' },
      ] : []),
    ] }]),
  ];

  return (
    <div className="flex flex-col md:flex-row gap-5 md:gap-6" data-testid="eng-layout">
      <ModuleSidebar icon={Wrench} title="技術" sections={sections} testid="eng-sidebar" />
      <main className="flex-1 min-w-0">
        <Outlet context={{ access }} />
      </main>
    </div>
  );
}
